import { useMemo } from 'react'
import type { InsuranceUpsellData } from './insuranceUpsellTypes'
import { min } from 'lib/array/arrayUtils'

interface Props {
  ableToViewLuxPlusBenefits: boolean
  luxPlusDiscountedInsuranceEnabled: boolean
  quote?: App.InsuranceQuote
  earliestItem?: InsuranceUpsellData
  latestItem?: InsuranceUpsellData
}
function useCheapestInsuranceQuotePrice({ ableToViewLuxPlusBenefits, luxPlusDiscountedInsuranceEnabled, quote, earliestItem, latestItem }: Props) {
  const [cheapestQuotePrice, cheapestQuoteLuxPlusPrice] = useMemo(() => {
    let cheapestQuotePrice = 0
    let cheapestQuoteLuxPlusPrice = 0

    if (quote && earliestItem && latestItem) {
      const policyQuotes = quote.policyQuotes
      cheapestQuotePrice = min(policyQuotes.map(item => item.pricePerPerson)) ?? 0

      if (ableToViewLuxPlusBenefits && luxPlusDiscountedInsuranceEnabled) {
        cheapestQuoteLuxPlusPrice = min(policyQuotes.map(item => item.luxPlusPricePerPerson)) ?? 0
      }
    }
    return [cheapestQuotePrice, cheapestQuoteLuxPlusPrice]
  }, [ableToViewLuxPlusBenefits, earliestItem, latestItem, luxPlusDiscountedInsuranceEnabled, quote])

  return [
    cheapestQuotePrice,
    cheapestQuoteLuxPlusPrice,
  ]
}

export default useCheapestInsuranceQuotePrice
